import useMutation from "src/hooks/useMutation";

function useMeUpdate(id) {
  return useMutation({
    path: `/api/v1/auth/me`,
    method: "PUT",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/auth/me`,
      shouldRevalidate: true,
    },
  });
}

export default useMeUpdate;
